import React from "react";
import { useContext,useState } from "react";
import PRODUCT from "./Product";

import { ShopContext } from "./Context";

const CartItem = (props) => {
    
    
  const { addToCart, cartItems,removeToCart } = useContext(ShopContext);
  const { id, productName, price, productImage, category, colour } = props.data;

  
return (
    <div className="mx-[25%]">
      <div className="w-[44rem] h-[14rem] rounded-3xl bg-slate-200 shadow-xl  mt-7  grid grid-cols-2 ">
        <div>
          <img
            className="mx-10 rounded-3xl py-2 w-[12rem] h-[14rem]"
            src={productImage}
          />
        </div>
        <div className=" my-[2rem]  ">
          <p className="text-2xl  font-serif  uppercase">{productName}</p>
          <p className="text-xl  font-sans">Description</p>
          <p className="text-2xl  font-serif "> ${price}</p>
          <button onClick={()=>removeToCart(id)}>-</button> <input value={cartItems[id]}   className="w-[4rem] text-center rounded-md" />  <button onClick={()=>addToCart(id)}>+</button>
        </div>
      </div>
      
    </div>
  );
};

export default CartItem;
